import React from 'react';

import PropTypes from 'prop-types';

const FrameComponent = (props) => {
  const {
    customId,
    height,
    onLoad,
    src,
    width,
  } = props;

  let newWidth = width.toString();
  let newHeight = height.toString();

  if (newWidth.includes('%') && !newWidth.includes('calc')) {
    newWidth = +newWidth.substring(0, newWidth.indexOf('%'));
    newWidth *= document.body.clientWidth / 100;
    newWidth = `${newWidth}px`;
  }

  if (newHeight.includes('%') && !newHeight.includes('calc')) {
    newHeight = +newHeight.substring(0, newHeight.indexOf('%'));
    newHeight *= document.body.clientHeight / 100;
    newHeight = `${newHeight}px`;
  }

  const style = {
    height: `${newHeight}${newHeight.includes('px') || Number.isNaN(+height) ? '' : 'px'}`,
    width: `${newWidth}${newWidth.includes('px') || Number.isNaN(+width) ? '' : 'px'}`,
  };

  return (
    <iframe
      title={`${src}?${Date.now()}`}
      src={src}
      height={`${newHeight}${newHeight.includes('px') || Number.isNaN(+height) ? '' : 'px'}`}
      width={`${newWidth}${newWidth.includes('px') || Number.isNaN(+width) ? '' : 'px'}`}
      style={style}
      id={customId}
      name={customId}
      onLoad={onLoad}
    />
  );
};

export default FrameComponent;

FrameComponent.propTypes = {
  customId: PropTypes.string,
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onLoad: PropTypes.func,
};

FrameComponent.defaultProps = {
  customId: '',
  height: '720px',
  onLoad: () => {},
  width: '1280px',
};
